import React, { useEffect, useState } from "react";
import {
  FiEdit2,
  FiCreditCard,
  FiTruck,
  FiSettings,
  FiLogOut,
  FiUpload,
  FiUser,FiChevronRight
} from "react-icons/fi"; 
import { Link } from "react-router-dom";
import axios from "axios";
import { baseurl, imgurl } from "../baseurl";
import Swal from "sweetalert2";

function Profile() {
  const customerId = localStorage.getItem("customerId");
  const [loading, setLoading] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [user, setUser] = useState({
    name: "",
    email: "",
    phone: "",
    address_line1: "",
    address_line2: "",
    city: "",
    state: "",
    country: "",
    postal_code: "",
    profile_image: "",
  });

    // 🟢 Define fetchUser outside useEffect
  const fetchUser = async () => {
    try {
      const res = await axios.get(`${baseurl}getUserById/${customerId}`);
      if (res.data?.data) {
        setUser(res.data.data);
      }
    } catch (err) {
      console.error("Error fetching user:", err);
      Swal.fire("Error", "Failed to fetch user details", "error");
    } finally {
      setLoading(false);
    }
  };

  // 🟢 Fetch user on mount
  useEffect(() => {
    if (customerId) fetchUser();
  }, [customerId]);


  // 🟢 Handle input changes
  const handleChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  // 🟢 Handle profile image upload
const handleImageChange = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const formData = new FormData();
  formData.append("profile_image", file);

  try {
    const res = await axios.post(`${baseurl}uploadProfileImage/${customerId}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    if (res.data?.success) {
      const imagePath = res.data.data?.profile_image;

      // ✅ Update user profile image
      setUser((prev) => ({
        ...prev,
        profile_image: `${imgurl}${imagePath}`,
      }));

      fetchUser();

      // ✅ SweetAlert Toast
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: "Profile image updated successfully!",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
      });
    }
  } catch (err) {
    Swal.fire({
      toast: true,
      position: "top-end",
      icon: "error",
      title: "Image upload failed!",
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
    });
  }
};


  // 🟢 Handle update
const handleUpdate = async () => {
  try {
    const res = await axios.put(`${baseurl}updateUserById/${customerId}`, user);
    if (res.data?.success) {
      Swal.fire({
        toast: true,
        icon: "success",
        title: "Profile updated successfully!",
        position: "top-end",
        showConfirmButton: false,
        timer: 2500,
        timerProgressBar: true,
      });
      setEditMode(false);
    }
  } catch (err) {
    Swal.fire({
      toast: true,
      icon: "error",
      title: "Failed to update profile",
      position: "top-end",
      showConfirmButton: false,
      timer: 2500,
      timerProgressBar: true,
    });
  }
};


  if (loading) return <div className="text-center py-5">Loading...</div>;

  return (
    <div className="container-fluid py-4 profile-page">
      {/* <h2 className="fw-bold mb-4 text-start">My Profile</h2> */}

        <nav aria-label="breadcrumb" className="breadcrumb-wrapper">
        <ol className="breadcrumb">
          <li className={`breadcrumb-item active`} >
                <Link to={`/`}> Home
                    <FiChevronRight className="breadcrumb-separator" />
                  </Link>
              </li> 
              <li className={`breadcrumb-item active pt2`} > 
                     My Profile 
              </li> 
        </ol>
      </nav>


      <div className="row">
        {/* Sidebar */}
        <div className="col-lg-4 mb-4">
          <div className="card shadow-lg text-center p-4 profile-card">
            <div className="position-relative d-inline-block">
              <img
                src={
                  user.profile_image
                    ? `${imgurl}${user.profile_image}`
                    : "https://i.pravatar.cc/150?img=3"
                }
                alt="User"
                className="rounded-circle shadow-sm profile-avatar"
                style={{ width: 120, height: 120, objectFit: "cover", border: "3px solid #f54c4d" }}
              />
              <label
                htmlFor="profileImage"
                className="btn btn-sm btn-light position-absolute bottom-0 end-0 border"
                style={{ borderRadius: "50%" }}
              >
                <FiUpload />
                <input
                  id="profileImage"
                  type="file"
                  accept="image/*"
                  hidden
                  onChange={handleImageChange}
                />
              </label>
            </div>

            <h4 className="fw-bold mt-3">{user.name || "Unnamed User"}</h4>
            <p className="text-muted mb-1">{user.email}</p>
            <p className="text-muted">{user.phone || "No phone added"}</p>

            <div className="d-grid gap-2 mt-3">
              <button
                className="btn btn-gradient btn-lg"
                onClick={() => setEditMode(!editMode)}
              >
                <FiEdit2 className="me-2" /> {editMode ? "Cancel" : "Edit Profile"}
              </button>
              <Link to="/logout" className="btn btn-outline-danger btn-lg">
                <FiLogOut className="me-2" /> Logout
              </Link>
            </div>
          </div>

         
        </div>

        {/* Main Form */}
        <div className="col-lg-8">
          <div className="card shadow-lg p-4 section-card">
            <h5 className="fw-bold mb-3">Profile Information</h5>

            <div className="row g-3">
              {[
                { label: "Full Name", name: "name" },
                { label: "Email", name: "email" },
                { label: "Phone", name: "phone" },
                { label: "Address Line 1", name: "address_line1" },
                { label: "Address Line 2", name: "address_line2" },
                { label: "City", name: "city" },
                { label: "State", name: "state" },
                { label: "Country", name: "country" },
                { label: "Postal Code", name: "postal_code" },
              ].map((field, i) => (
                <div className="col-md-6" key={i}>
                  <label className="form-label fw-semibold">{field.label}</label>
                  <input
                    type="text"
                    className="form-control"
                    name={field.name}
                    value={user[field.name] || ""}
                    onChange={handleChange}
                    disabled={!editMode}
                  />
                </div>
              ))}
            </div>

            {editMode && (
              <button className="btn btn-primary mt-4 w-100" onClick={handleUpdate}>
                Save Changes
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Profile;
